<template>
    <div id="message-home" class="well">
        <p>Manage all your messages on this page. Click/tap an existing message to reply, 
            or start a new chat to message other participants.</p>
        <p>Click a participant's name in the chat view pane to open their online profile.</p>
        
    </div>
</template>

<script>
export default {
    name: "MessageIndex",
}
</script>

<style>
</style>